import { styled } from 'react-alicerce-components';

export const ProgramCardContainer = styled.div`
  gap: 1rem;
  
  b {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .remove-card {
    cursor: pointer;
    width: 30px;
    height: 30px;
    aspect-ratio: 1;
    background: red;
    border-radius: 100px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      display: flex;
      align-items: center;
      svg {
        width: 25px;
        height: 25px;
      }
    }
  }
`;
